module.exports = __webpack_public_path__ + "img/QRCode.df42b041.png";